/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import api from './api';
import type { AuditEntry, AuditQueryParams, AuditQueryResult } from '../types/audit';

export type { AuditEntry, AuditQueryParams, AuditQueryResult };

export const auditService = {
  async query(params: AuditQueryParams): Promise<AuditQueryResult> {
    const query = new URLSearchParams();

    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.sort) query.set('sort', params.sort);
    if (params.startTime) query.set('startTime', params.startTime);
    if (params.endTime) query.set('endTime', params.endTime);
    if (params.actor?.trim()) query.set('actor', params.actor.trim());
    if (params.action?.trim()) query.set('action', params.action.trim());
    if (params.entityType?.trim()) query.set('entityType', params.entityType.trim());
    if (params.entityKey?.trim()) query.set('entityKey', params.entityKey.trim());
    if (params.objectId?.trim()) query.set('objectId', params.objectId.trim());

    const qs = query.toString();
    const path = qs ? `/api/audit?${qs}` : '/api/audit';
    const { data } = await api.get<AuditQueryResult>(path);
    return data;
  },
};
